import { render, staticRenderFns } from "./PublicAccess.vue?vue&type=template&id=393267d6&scoped=true&"
import script from "./PublicAccess.vue?vue&type=script&lang=js&"
export * from "./PublicAccess.vue?vue&type=script&lang=js&"
import style0 from "./PublicAccess.vue?vue&type=style&index=0&id=393267d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393267d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
